export const dialogPaper = {
  borderRadius: "8px",
  minWidth: "400px",
  padding: 0,
};

export const dialogContent = {
  padding: "1.5rem",
  paddingBottom: "1rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const contentBox = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
};

export const iconBox = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.8rem",
  borderRadius: "50%",
  marginBottom: "1rem",
  marginLeft: "1rem",
};

export const messageText = {
  fontSize: "14px",
  margin: 0,
  textAlign: "center",
  color: "#000000",
};

export const dialogActions = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "0.8rem 1.5rem 1.5rem 1.5rem",
  gap: "1rem",
  "& > :not(style) ~ :not(style)": {
    marginLeft: 0,
  },
};

export const cancelButton = {
  color: "#374151",
  borderColor: "#d1d5db",
  textTransform: "none",
  fontSize: "14px",
  padding: "6px 16px",
  minWidth: "auto",
  marginLeft: 0,
  "&:hover": {
    borderColor: "#9ca3af",
    backgroundColor: "#f3f4f6",
  },
};

export const confirmButton = (backgroundColor) => ({
  backgroundColor: backgroundColor,
  color: "#F3F3F3",
  textTransform: "none",
  fontSize: "14px",
  padding: "6px 16px",
  minWidth: "auto",
  marginLeft: 0,
  "&:hover": {
    backgroundColor: backgroundColor,
    opacity: 0.9,
  },
});

export const iconStyles = {
  fontSize: 24,
  color: "white",
};
